/*
 * Public API Surface of textme
 */

export * from './lib/textme.service';
export * from './lib/textme.component';
export * from './lib/textme.module';
